module.exports = {

    chart: {
        BURNUP: 'burnup',
        BURNDOWN: 'burndown',
    },

    secondColumn: {
        RECENT_ACTIVITY: 'recentActivity',
        TASKS_BY_USER: 'tasksByUser',
    }
};